export const getAuthErrorMessage = (errorCode: string): string => {
    switch (errorCode) {
        case 'auth/email-already-in-use':
            return 'Este e-mail já está sendo usado por outra conta.'
        case 'auth/invalid-email':
            return 'O endereço de e-mail é inválido.'
        case 'auth/operation-not-allowed':
            return 'Esta operação não é permitida.'
        case 'auth/weak-password':
            return 'A senha deve ter pelo menos 6 caracteres.'
        case 'auth/user-disabled':
            return 'Esta conta de usuário foi desativada.'
        case 'auth/user-not-found':
            return 'Não encontramos uma conta com este e-mail.'
        case 'auth/wrong-password':
            return 'Senha incorreta. Tente novamente.'
        case 'auth/invalid-credential':
            return 'As credenciais fornecidas são inválidas.'
        case 'auth/too-many-requests':
            return 'Acesso temporariamente bloqueado por muitas tentativas. Tente mais tarde.'
        case 'auth/network-request-failed':
            return 'Erro de conexão. Verifique sua internet.'
        case 'auth/requires-recent-login':
            return 'Para realizar esta operação, por favor faça login novamente.'
        default:
            return 'Ocorreu um erro inesperado. Tente novamente.'
    }
}
